import { store } from 'react-easy-state'

const _store = store({
  polType: '',
  polName: '',
  id: '',
  custName: '',
  plateNo: '',
  startDate: '',
  endDate: '',
  repairType: '',
  status: '',
  paymentTerm: '',
  paymentAmount: '',
  polIdSelected: '',
  custId: '',
  email: '',
  mobile: '',

  setPolicyType(polType: string) {
    _store.polType = polType
  },

  setMotor(
    polName: string,
    id: string,
    custName: string,
    plateNo: string,
    startDate: string,
    endDate: string,
    repairType: string,
    status: string | undefined
  ) {
    _store.polName = polName
    _store.id = id
    _store.custName = custName
    _store.plateNo = plateNo
    _store.startDate = startDate
    _store.endDate = endDate
    _store.repairType = repairType
    _store.status = status
  },

  setAnH(
    polName: string,
    id: string,
    custName: string,
    startDate: string,
    endDate: string,
    status: string | undefined,
    paymentTerm: string,
    paymentAmount: string | number
  ) {
    _store.polName = polName
    _store.id = id
    _store.custName = custName
    _store.startDate = startDate
    _store.endDate = endDate
    _store.status = status
    _store.paymentTerm = paymentTerm
    _store.paymentAmount = paymentAmount
  },

  setPolIdSelected(polIdSelected: string) {
    _store.polIdSelected = polIdSelected
  },

  setInfo(custId: string, email: string, mobile: string) {
    _store.custId = custId
    _store.email = email
    _store.mobile = mobile
  }
})

export default _store
